











import { Component, Vue } from 'vue-property-decorator'

@Component
class Mir extends Vue {
  successEventCallback = (event: MessageEvent) => {
    try {
      const data = JSON.parse(event.data)
      if (data.isSuccess) {
        this.$emit('success')
      }
    } catch (error) {
      // Игнорируем сообщение, если там не JSON.
    }
  }

  mounted(): void {
    window.addEventListener('message', this.successEventCallback)
  }

  beforeDestroyed(): void {
    window.removeEventListener('message', this.successEventCallback)
  }
}

export default Mir
